export class Semaphore {
    private _count: number;
    private _waiters: Array<() => void> = [];

    constructor(initialCount: number = 0) {
        this._count = initialCount;
    }

    async acquire(): Promise<void> {
        // If resources available, take one immediately
        if (this._count > 0) {
            this._count--;
            return;
        }

        // Otherwise, queue up and wait
        return new Promise<void>(resolve => {
            this._waiters.push(resolve);
        });
    }

    release(): void {
        // If someone is waiting, wake them directly (don't increment count)
        const waiter = this._waiters.shift();
        if (waiter) {
            waiter();
        } else {
            // No waiters, so increment the count
            this._count++;
        }
    }
}